import { createAction, props } from '@ngrx/store';
import { Security } from '../_models/security';

// Action types
export const loadSecurities = createAction('[Security] Load Securities');
export const loadSecuritiesSuccess = createAction(
  '[Security] Load Securities Success',
  props<{ securities: Security[] }>()
);
export const loadSecuritiesFailure = createAction(
  '[Security] Load Securities Failure',
  props<{ error: any }>()
);

export const addSecurity = createAction('[Security] Add Security', props<{ security: Security }>());
export const addSecuritySuccess = createAction(
  '[Security] Add Security Success',
  props<{ security: Security }>()
);
export const addSecurityFailure = createAction(
  '[Security] Add Security Failure',
  props<{ error: any }>()
);

export const updateSecurity = createAction(
  '[Security] Update Security',
  props<{ security: Security }>()
);
export const updateSecuritySuccess = createAction(
  '[Security] Update Security Success',
  props<{ security: Security }>()
);
export const updateSecurityFailure = createAction(
  '[Security] Update Security Failure',
  props<{ error: any }>()
);

export const deleteSecurity = createAction('[Security] Delete Security', props<{ id: number }>());
export const deleteSecuritySuccess = createAction(
  '[Security] Delete Security Success',
  props<{ id: number }>()
);
export const deleteSecurityFailure = createAction(
  '[Security] Delete Security Failure',
  props<{ error: any }>()
);
